import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createCity, getAllCities } from "../actions/cityActions";
import ActiveFormModal from "../components/ActiveFormModal";
import AdminGeneralEditModal from "../components/AdminGeneralEditModal";
import { paginationDataToShow } from "../actions/generalActions";
import AdminCitiesListRow from "../components/AdminCitiesListRow";

const AdminCities = () => {
  const city = useSelector((state) => state.city);
  const store = useSelector((state) => state.store);
  const navigate = useNavigate();

  const [values, setValues] = useState({
    name: "",
    status: "",
    latitude: "",
    longitude: "",
  });
  // console.log(values, "values");
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  const dispatch = useDispatch();

  const cityData = {
    name: values.name,
    status: values.status ? values.status : true,
    longitude: values.longitude,
    latitude: values.latitude,
  };

  const cb = () => {
    dispatch(getAllCities());
    setValues({
      name: "",
      status: "",
      latitude: "",
      longitude: "",
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("first");
    for (let key of Object.keys(cityData)) {
      if (cityData[key] === "") {
        delete cityData[key];
      }
    }
    dispatch(createCity(cityData, cb));
    // setValues({
    //   name: "",
    //   status: "",
    //   latitude: "",
    //   longitude: "",
    // });
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc"); //asc, desc
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(25); // Set your default limit here

  // Function to handle pagination, sorting, and searching
  const handlePagination = (page, field, order, search, newLimit) => {
    let newPage;
    if (page < 1) {
      newPage = 1;
    } else if (page > paginatedData.totalPages) {
      newPage = paginatedData.totalPages;
    } else {
      newPage = page;
    }
    setCurrentPage(newPage);
    setSortField(field);
    setSortOrder(order);
    setSearchTerm(search);
    setLimit(newLimit);
  };

  const fullData = city?.city;
  // Use the pagination function to get the data for the current page
  const paginatedData = paginationDataToShow(
    limit,
    currentPage,
    fullData,
    sortField,
    sortOrder,
    searchTerm
  );
  // Function to handle sorting icon click
  const handleSortClick = (field, order) => {
    // Call handlePagination with sorting parameters
    handlePagination(currentPage, field, order, searchTerm, limit);
  };
  // Function to determine the color based on the current sorting order
  const getArrowColor = (field, direction) => {
    return sortField === field && sortOrder === direction
      ? "#000000"
      : "#A0A0A0";
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card rounded-1">
                  <div className="card-header py-3">
                    <h5 className="card-title">City Information</h5>
                  </div>
                  <div className="card-body p-3">
                    <form onSubmit={handleSubmit} className="row">
                      <div className="col-12">
                        <div className="mb-3">
                          <label for="cityname" className="form-label">
                            City Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="cityname"
                            placeholder="Enter City Name"
                            value={values.name}
                            onChange={handleChange("name")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label for="Latitude" className="form-label">
                            Latitude
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Latitude"
                            placeholder="Latitude"
                            value={values.latitude}
                            onChange={handleChange("latitude")}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label for="Longitude" className="form-label">
                            Longitude
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Longitude"
                            placeholder="Longitude"
                            value={values.longitude}
                            onChange={handleChange("longitude")}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label for="Longitude" className="form-label">
                            City Status
                          </label>
                          <select
                            className="form-select"
                            id="City Status"
                            value={values.status}
                            onChange={handleChange("status")}
                          >
                            <option value="0" disabled selected>
                              Select Status
                            </option>
                            <option value={true}>Active</option>
                            <option value={false}>Deactive</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-success">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-sm-8 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Cities</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                          <button className="btn btn-warning">
                            Bulk CSV Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mx-2 my-2">
                      <div className="col">
                        <form action="">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search City"
                            />
                            <button className="btn btn-primary" type="submit">
                              Search
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>City Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {city &&
                            city?.city &&
                            city?.city?.length > 0 &&
                            // city?.city?.map((current, i) => {
                            paginatedData?.results.map((current, i) => {
                              if (current.delete === false) {
                                return (
                                  <AdminCitiesListRow
                                    current={current}
                                    i={i}
                                    key={i}
                                  />
                                );
                              }
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">
                        Showing{" "}
                        {1 +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        to{" "}
                        {paginatedData?.displayingResults +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        of {paginatedData?.totalResults} entries
                      </p>

                      <nav aria-label="...">
                        <ul className="pagination">
                          {/* Previous Button */}
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <NavLink
                              className="page-link"
                              href="#"
                              tabIndex="-1"
                              aria-label="Previous"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage > 1) {
                                  handlePagination(
                                    currentPage - 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Previous
                            </NavLink>
                          </li>

                          {/* Dynamic Pagination Buttons */}
                          {paginatedData?.paginationArr?.length > 0 &&
                            Array.from(
                              {
                                length:
                                  paginatedData.endPage -
                                  paginatedData.startPage +
                                  1,
                              },
                              (_, i) => {
                                const current = paginatedData?.startPage + i;
                                return paginatedData?.currentPageNumber ===
                                  current ? (
                                  <li className="page-item active" key={i}>
                                    <a className="page-link" href="#">
                                      {current}{" "}
                                      <span className="sr-only">(current)</span>
                                    </a>
                                  </li>
                                ) : (
                                  <li className="page-item" key={i}>
                                    <NavLink
                                      className="page-link"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handlePagination(
                                          parseInt(current),
                                          sortField,
                                          sortOrder,
                                          searchTerm,
                                          limit
                                        );
                                      }}
                                    >
                                      {current}
                                    </NavLink>
                                  </li>
                                );
                              }
                            )}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              currentPage === paginatedData?.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <a
                              className="page-link"
                              href="#"
                              aria-label="Next"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage < paginatedData?.totalPages) {
                                  handlePagination(
                                    currentPage + 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminCities;
